import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'cpBreadCrumb'})
export class BreadCrumbPipe implements PipeTransform {

	transform(value: string): any {
		let temp = value.split(">");
		let retValue: string = "";
		for (let i = 0; i < temp.length - 1; i++) {
			retValue += temp[i] + '<span class="separator">></span>';
		}
		retValue += '<span class="active-text">' + temp[temp.length - 1] + '</span>';
		return retValue;
	}
}
